export default "__VITE_ASSET__2839e0ab__"